export const SESSION_KEY_NAME = '@scontti/gerencial-session'

export const COOKIES_CONFIRM_KEY_NAME = '@scontti/gerencial-user-agreed-cookies'

export const IS_AUTH_KEY_NAME = '@scontti/gerencial-auth'
